/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  DialogActions,
  Grid,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import {
  POST_AUTHORIZATION_COMMENTS_FAILURE
} from 'modules/authorizations/store/types/authorizationTypes';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import Spinner from 'modules/common/spinner.component';
import { postAuthorizationComment } from 'modules/authorizations/store/actions/authorizations.actions';
import { insertFeeComment } from 'modules/fees/fees.actions';
import { INSERT_FEE_COMMENT_FAILURE } from 'modules/fees/fees.types';
import { showToast } from 'modules/layout/layout.actions';

const useStyles = makeStyles(theme => ({
  card: { width: '100%', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between' },
  cardContainer: { maxWidth: '100% !important', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  iconRow: { display: 'flex', flexDirection: 'row' },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  mb2: { marginBottom: '4px', marginRight: '16px' }
}));

// const EXCEPTION_GUID = 'cb2f2bde-cbb6-4e9f-a5d0-95a31815a75a';

const CreateAuthCommentCard = props => {
  const {
    feeRecordDetails,
    feeRule,
    feeComments,
    // enumerations,
    isReadOnly
  } = props;

    const classes = useStyles();
    const theme = createTheme({ palette: { primary: COLOR_PRIMARY, secondary: COLOR_SECONDARY, warning: COLOR_WARNING } });

    // const [regardingTypeId, setRegardingTypeId] = useState(EXCEPTION_GUID);
    const [comment, setComment] = useState('');
    const [isLoading, setIsLoading] = useState(false);

  // const authCommentRegarding =
  //   enumerations && enumerations.authCommentRegarding && enumerations.authCommentRegarding.length > 0
  //     ? enumerations.authCommentRegarding.filter(s => s.isActive === true)
  //     : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

    // const filteredRegardingOptions = authCommentRegarding.filter(
    //   option => {
    //       if(option.additionalField === '1df8f463-58a7-4a2b-b4dc-4a94493f683e' || (option.additionalField === '11111111-1111-1111-1111-111111111111' && option.title !== 'DSP'))
    //       return option;
    //   }).sort((a, b) => 
    //     a.title.localeCompare(b.title));

    const saveComment = async () => {
        setIsLoading(true);

        // if(regardingTypeId === EXCEPTION_GUID){

        //   let commentData = {
        //     taskId: null,
        //     isTransfereeViewable: false,
        //     isClientViewable: false,
        //     isPinned: false,
        //     regardingId: regardingTypeId,
        //     serviceId: '1df8f463-58a7-4a2b-b4dc-4a94493f683e',
        //     subject: 'Review Comment',
        //     comment: comment,
        //     addedByUserId: 0, // Backend will populate this field based on the logged in user,
        //     modifiedByUserId: 0, // Backend will populate this field based on the logged in user,
        //     createdParty: '8A7D7554-57F7-4A91-BC1D-2148CE669AD1', // Backend will populate this field based on the logged in user,
        //     exceptionReason: 'Fee Review Exception',
        //     requestedAmount: feeRule ? feeRule.feeAmount : 0,
        //     statusId: '00000000-0000-0000-0000-000000000000', // Backend will populate this field based on the workflow status,
        //     exceptionCodeId: '00000000-0000-0000-0000-000000000000', // This will be populated if the comment is regarding an exception,
        //     categoryId: '00000000-0000-0000-0000-000000000000', // This will be populated based on the category selected for the comment,
        //     requestTypeId: '00000000-0000-0000-0000-000000000000', // This will be populated based on the type of request if applicable,
        //     approvedById: 0,
        //     approvedDate: null,
        //     approvedAmount: 0,
        //     exceptionTypeId: '00000000-0000-0000-0000-000000000000', // This will be populated if the comment is regarding an exception
        //     requestedItem: '',
        //     addedOn: new Date(),
        //     templateId: 0,
        //     emailTemplateSentDate: null,
        //     exceptionApprovers: [],
        //     exceptionLineItems: []
        //   }
        //     const resp = await props.postAuthorizationComment(
        //         commentData,
        //         feeRecordDetails.authorizationFileId );

        //     if (resp.type === POST_AUTHORIZATION_COMMENTS_FAILURE) {
        //     props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
        //     } else {
        //       props.showToast('Comment created successfully', TOAST_MESSAGE_SEVERITY_SUCCESS);
        //       setRegardingTypeId(EXCEPTION_GUID);
        //       setComment('');
        
        //     }
        // }
        // else {
          let commentData = {
            taskId: null,
            isTransfereeViewable: false,
            isClientViewable: false,
            isPinned: false,
            isException: false,
            regardingId: '92c14379-c7ac-40b7-93a4-4904f9f5dfb0',
            serviceId: '1df8f463-58a7-4a2b-b4dc-4a94493f683e',
            subject: feeRecordDetails && feeRule
              ? `Fee Review Comment: $${feeRule.feeAmount}, ${feeRule.feeLineDescription}, ${feeRecordDetails.feeRecordId}`
              : 'Fee Review Comment',
            comment: comment,
            addedByUserId: 0, // Backend will populate this field based on the logged in user,
            modifiedByUserId: 0, // Backend will populate this field based on the logged in user,
            createdParty: '8a7d7554-57f7-4a91-bc1d-2148ce669ad1', // Backend will populate this field based on the logged in user,
            exceptionReason: 'Fee Review Exception',
            requestedAmount: feeRule ? feeRule.feeAmount : 0,
            statusId: '00000000-0000-0000-0000-000000000000', // Backend will populate this field based on the workflow status,
            exceptionCodeId: '00000000-0000-0000-0000-000000000000', // This will be populated if the comment is regarding an exception,
            categoryId: '00000000-0000-0000-0000-000000000000', // This will be populated based on the category selected for the comment,
            requestTypeId: '00000000-0000-0000-0000-000000000000', // This will be populated based on the type of request if applicable,
            approvedById: 0,
            approvedDate: null,
            approvedAmount: 0,
            exceptionTypeId: '00000000-0000-0000-0000-000000000000', // This will be populated if the comment is regarding an exception
            requestedItem: '',
            addedOn: new Date(),
            templateId: 0,
            emailTemplateSentDate: null,
            exceptionApprovers: [],
            exceptionLineItems: []
          }
            const resp = await props.postAuthorizationComment(
            commentData,
            feeRecordDetails.authorizationFileId

            );

            if (resp.type === POST_AUTHORIZATION_COMMENTS_FAILURE) {
                props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
            } else {
              const createdCommentId = resp?.response?.[resp.response.length - 1]?.commentId;

              if (!createdCommentId) {
                props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
                setIsLoading(false);
                return;
              }

              const insertCommentResp = await props.insertFeeComment(feeRecordDetails.feeRecordId, createdCommentId);
              if (insertCommentResp.type === INSERT_FEE_COMMENT_FAILURE) {
                props.showToast('Failed to associate comment to fee record, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
              }
              else {
                props.showToast('Comment created successfully', TOAST_MESSAGE_SEVERITY_SUCCESS);
                // setRegardingTypeId(EXCEPTION_GUID);
                setComment('');
              }        
            }
    
        setIsLoading(false);
      };

  const removeHtml = (comment) => {
    const plainText = comment.replace(/<[^>]*>?/gm, '');

    return plainText; 
  }

  return (
      <ThemeProvider theme={theme}>
            <Card className={classes.card}>
              <Box>
                <CardContent className={classes.cardContainer}>
                  <div className="row justify-space-between align-center">
                    <div className={classes.iconRow}>
                      <Tooltip title="Voucher Details" placement="right">
                        <FontAwesomeIcon icon={['fas', 'file-contract']} size="2x" />
                      </Tooltip>
                      <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                        Comments
                      </Typography>
                    </div>
                  </div>
                </CardContent>
                <CardContent sx={{ padding: '10px', marginLeft: '10px', paddingTop: '0px' }}>
                  <Grid container spacing={1} columns={5}>   
                    <Box>
                      <Typography variant="body2" sx={{ marginBottom: '8px' }}>
                        Previously Added Comments:
                      </Typography>
                    </Box>
                    { feeComments && feeComments.length > 0 && feeComments.map((comment, index) => (
                      <Grid item md={12} key={index} sx={{ marginBottom: '10px' }}>
                        <Box sx={{ border: '1px solid #ccc', borderRadius: '4px', padding: '10px' }}>
                          <Typography variant="body2">
                            {new Date(comment.addedOn).toLocaleString()}
                          </Typography>
                          <Typography variant="body2">
                            {removeHtml(comment.comment)}
                          </Typography>
                        </Box>
                      </Grid>
                    )) }
                    
                    {/* <Grid item md={6}>
                       <Box>
                        <InputLabel>Regarding</InputLabel>
                        <Select
                          value={regardingTypeId || ZERO_GUID}
                          sx={{ maxWidth: '180px', minWidth: '180px' }}
                          disabled={isReadOnly}
                          onChange={e => setRegardingTypeId(e.target.value)}
                          input={<OutlinedInput labelWidth={100} />}
                        >
                          {filteredRegardingOptions.map(opt => (
                            <MenuItem key={opt.id} value={opt.id}>
                              {opt.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </Box>

                    </Grid> */}
                    <Grid item md={4}>
                      <TextField
                        label="Comment"
                        multiline
                        fullWidth
                        minRows={3}
                        maxRows={6}
                        value={comment}
                        onChange={e => setComment(e.target.value)}
                        disabled={isReadOnly}
                      />
                    </Grid>
                  </Grid>
                  {isLoading && (
                    <DialogActions sx={{ p: '1.25rem' }}>
                        <Spinner />
                    </DialogActions>
                    )}
                    {!isLoading && (
                    <DialogActions sx={{ p: '1.25rem' }}>
                        <Button color="primary" type="submit" variant="contained" disabled={isReadOnly} onClick={saveComment}>
                        Save New Comment
                        </Button>
                    </DialogActions>
                    )}
                </CardContent>
              </Box>
            </Card>
      </ThemeProvider>
    );
  
};

export default compose(
  connect(null, {
    postAuthorizationComment,
    insertFeeComment,
    showToast
  })
)(CreateAuthCommentCard);
